import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MetricCardComponent } from '../../../../../../../core/components/metric-card/metric-card.component';
import { BillingService, MinimumCommitResponse } from '../../../../services/billing.service';
import { BaseComponent } from '../../../../../../../core/shared/common/base.component';

@Component({
  selector: 'app-billing-summary',
  standalone: true,
  imports: [CommonModule, MetricCardComponent],
  templateUrl: './billing-summary.component.html',
  styleUrl: './billing-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingSummaryComponent extends BaseComponent {
  private billingService = inject(BillingService);

  public organizationId = input.required<number>();

  public data = signal<MinimumCommitResponse | null>(null);
  public isLoading = signal<boolean>(true);

  constructor() {
    super();
    effect(
      () => {
        const id = this.organizationId();
        if (!id) return;
        this.loadMinimumCommit(id);
      },
      { allowSignalWrites: true }
    );
  }

  private loadMinimumCommit(id: number): void {
    this.isLoading.set(true);
    this.billingService
      .getMinimumCommit(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.data.set(res);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error('Failed to load minimum commit:', err);
          this.isLoading.set(false);
        },
      });
  }
}
